/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import Icon from './assets/close.svg';

const UNSET = 'unset';

export const StyledIcon = styled(Icon)`
  max-height: 20px;
`;

export const StyledButton = styled.button`${(props) => {
  const cl = props.styled?.color || UNSET;
  const ff = props.styled?.fontFamily || UNSET;
  const fs = props.styled?.fontSize || UNSET;

  return css`
    && {
      font-family: ${ff};
      font-size: ${fs};
      color: ${cl};
      z-index: 200;
      border: none;
      background-color: transparent;
      padding: 0;
    }
  `;
}}`;
